import { memo } from "react";
import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { SonicImageDplus } from "../../../../atoms/sonic-image";
import { Link } from "../../../../atoms/link";
import { PlaceholderImage } from "../../../../atoms/placeholder-image";
import { getIsMobile } from "../../../../../utils/isMobile";
import * as styles from "./styles.css";
export const CategoryCard = memo(({ desktopImg, urlM = M.empty(), name }) => {
    const route = urlM && M.fromMaybe(urlM, "");
    return (React.createElement("div", { className: styles.categoryWrapper, id: "#homeCategory" },
        React.createElement(Link, { href: route },
            React.createElement("div", { className: cn(styles.categoryThumbnailContainer, {
                    [styles.hoverable]: !getIsMobile(),
                }) },
                React.createElement("div", { className: styles.thumbnailImageContainer },
                    React.createElement("div", { className: styles.thumbnailImageWrapper },
                        React.createElement(PlaceholderImage, null),
                        desktopImg && (React.createElement(SonicImageDplus, { src: desktopImg.src, quality: 75, className: styles.thumbnailImage, width: 600 })),
                        React.createElement("div", { className: styles.nameWrapper },
                            React.createElement("span", { className: styles.name }, name))))))));
});

